export default {
  NEEDS_ATTENTION: 'NEEDS_ATTENTION',
  AT_RISK: 'AT_RISK',
  ON_TRACK: 'ON_TRACK',
} as const
